import { AbstractControl, ValidationErrors, ValidatorFn } from "@angular/forms";
import * as CryptoJS from "crypto-js";

export interface CompanyDataModel {
  companyId: number;
  companyCode: string;
  companyName: string;
  emailAddress?: string;
}

export function alphaNumericValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const valid = /^[a-zA-Z0-9]*$/.test(control.value);
    return valid ? null : { alphaNumeric: true };
  };
}


const encryptSecretKey = 'd1e5f9a2b4c8d3e6f7a1b2c3d4e5f6a7';
export function encryptData(plaintext: string) {
  const key = CryptoJS.enc.Utf8.parse(encryptSecretKey); // Convert key into WordArray (using Utf8)
  const iv = CryptoJS.lib.WordArray.create([0x00, 0x00, 0x00, 0x00]); // Use zero vector as IV
  const encrypted = CryptoJS.AES.encrypt(plaintext, key, { iv: iv }); // Encrypt using AES with CBC, PKCS7
  return encrypted.toString(); // Convert ciphertext to string
}

export function decryptData(ciphertextB64: string) {
  // Base64 encoded ciphertext, 32 bytes string as key
  const key = CryptoJS.enc.Utf8.parse(encryptSecretKey); // Convert into WordArray (using Utf8)
  const iv = CryptoJS.lib.WordArray.create([0x00, 0x00, 0x00, 0x00]); // Use zero vector as IV
  const decrypted = CryptoJS.AES.decrypt(ciphertextB64, key, { iv: iv }); // By default: CBC, PKCS7
  return decrypted.toString(CryptoJS.enc.Utf8); // Convert into string (using Utf8)
}

export function convertBase64ToPdfUrl(
  base64: string,
  type: "application/pdf" | "text/csv" | string = "application/pdf"
) {
  // Assuming base64 string without MIME type prefix; add it explicitly
  const base64WithPrefix = `data:${type};base64,${base64}`;

  // Convert base64 to a Blob
  const base64Response = atob(base64); // Directly use base64 as it's without prefix here
  const length = base64Response.length;
  const binaryData = new Uint8Array(length);

  for (let i = 0; i < length; i++) {
    binaryData[i] = base64Response.charCodeAt(i);
  }

  const blob = new Blob([binaryData], { type: type });

  // Create a URL for the Blob
  const blobUrl = URL.createObjectURL(blob);

  // Return the Blob URL
  return blobUrl;
}

export const downloadFileFromUrl = (blobUrl: string, fileName: string): void => {
  const downloadLink = document.createElement("a");
  downloadLink.href = blobUrl;
  downloadLink.download = fileName;
  downloadLink.style.display = "none";
  document.body.appendChild(downloadLink);
  downloadLink.click();
  document.body.removeChild(downloadLink);
  URL.revokeObjectURL(blobUrl);
};

export const getPreviousMonthRange = (
  monthsBack: number = 1
): {
  start: Date;
  end: Date;
} => {
  const today = new Date();
  const month = today.getMonth() - monthsBack;
  const year = today.getFullYear();

  // Adjust year and month if monthsBack leads to a previous year
  const actualYear = month >= 0 ? year : year + Math.floor(month / 12);
  const actualMonth = month >= 0 ? month : 12 + (month % 12);

  // Create the start date of the calculated month
  const start = new Date(actualYear, actualMonth, 1);
  start.setHours(0, 0, 0, 0);

  // Get the last day of the current month
  const currentMonthLastDay = new Date(year, today.getMonth() + 1, 0);
  currentMonthLastDay.setHours(23, 59, 59, 999);

  return {
    start: new Date(start),
    end: new Date(currentMonthLastDay)
  };
};